import { Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';
import { Result, Button } from 'antd';
import { isMenuItemVisible, type MenuPermission } from '@/layouts/menu-access';

interface RequirePermissionProps {
  /** 访问该路由需要的权限标识，支持单一权限或任一即可 */
  permission: MenuPermission;
}

/**
 * 路由级权限守卫
 * 没有对应权限时显示 403 页面，而不是空白页
 */
export function RequirePermission({ permission }: RequirePermissionProps) {
  const permissions = useAuthStore((s) => s.permissions);

  if (!isMenuItemVisible(permission, permissions)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="抱歉，你没有权限访问此页面"
        extra={
          <Button type="primary" onClick={() => window.history.back()}>
            返回上一页
          </Button>
        }
      />
    );
  }

  return <Outlet />;
}
